import { render } from "./FooterView.vue?vue&type=template&id=1a3736c0&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=1a3736c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3736c0"]])

export default __exports__